import { WorkOrderStatusEnum } from 'gql/graphql';
import type { Position } from 'uikit';
import { Tooltip } from 'uikit';

import type React from 'react';

import { WorkOrderAddUERTable } from '../WorkOrderAddUERTable';
import type { WorkOrderChapters } from '../workorderTypes';

interface IWorkOrderAddUERProps {
    filters: { objectId: number; subObjectId: number; chapter: WorkOrderChapters };
    constructionTypeId: number;
    reloadWorkOrder: () => void;
    workOrderStatus?: WorkOrderStatusEnum;
    contractId?: number;
    tooltipPosition?: Position;
    tooltipOuterOpened?: boolean;
    isOpenedOuter: boolean;
    closeOuterHandler: () => void;
}

export const WorkOrderAddUER: React.FC<IWorkOrderAddUERProps> = (props) => {
    const {
        filters,
        reloadWorkOrder,
        constructionTypeId,
        workOrderStatus,
        contractId,
        tooltipOuterOpened,
        tooltipPosition,
        isOpenedOuter,
        closeOuterHandler,
    } = props;

    const { subObjectId, chapter, objectId } = filters;
    const isStatusWorkOrderInProgress = workOrderStatus === WorkOrderStatusEnum.InProgress;
    const isFiltersChecked = subObjectId && chapter && objectId;

    return (
        <>
            {subObjectId && chapter && isOpenedOuter && (
                <WorkOrderAddUERTable
                    objectId={subObjectId}
                    contractId={contractId}
                    chapter={chapter as any}
                    onCancel={closeOuterHandler}
                    reloadWorkOrder={reloadWorkOrder}
                    constructionTypeId={constructionTypeId}
                    workOrderStatus={workOrderStatus}
                    shouldAddToActKC2={isStatusWorkOrderInProgress}
                />
            )}
            {tooltipOuterOpened && (
                <Tooltip size="s" direction="rightCenter" position={tooltipPosition} isInteractive={false}>
                    {!isFiltersChecked
                        ? 'Выберите раздел, объект и подобъект'
                        : 'В НЗ в статусе "В работе" добавление расценок доступно через создание Акта КС-2'}
                </Tooltip>
            )}
        </>
    );
};

WorkOrderAddUER.displayName = 'WorkOrderAddUER';
